export enum ControlsMutationEnum {
  UPDATE_CONTROL_CASES = "UPDATE_CONTROL_CASES",
  UPDATE_CURRENT_CONTROL_CASE = "UPDATE_CURRENT_CONTROL_CASE",
  CONTROL_CASES_FETCH = "CONTROL_CASES_FETCH",
  SAVE_CONTROL_DASHBOARD_OPTIONS = "SAVE_CONTROL_DASHBOARD_OPTIONS",
  REGISTER_PAGE_LOAD_ERROR = "REGISTER_PAGE_LOAD_ERROR",
  REGISTER_LOADING = "REGISTER_LOADING",
  SAVE_CONTROL_PAGING_OPTIONS = "SAVE_CONTROL_PAGING_OPTIONS",
  CONTROL_TRANSACTIONS_FETCH = "CONTROL_TRANSACTIONS_FETCH",
  UPDATE_CONTROL_TRANSACTIONS = "UPDATE_CONTROL_TRANSACTIONS",
  UPDATE_EMBED_PARAMS = "UPDATE_EMBED_PARAMS",
  UPDATE_RISK_CONTROL_TYPE = "UPDATE_RISK_CONTROL_TYPE",
  CASE_UPDATE_SUCCESSFUL = "CASE_UPDATE_SUCCESSFUL"
}
